import { MapPin, Globe2 } from "lucide-react";

/**
 * Compact "Showing Karen · All" pill row for Feed / Alerts / Events pages.
 * onToggle receives true if user wants to see everything, false to scope to community.
 */
export default function CommunityFilterBar({ active, showAll, onToggle }) {
  return (
    <div
      data-testid="community-filter-bar"
      className="inline-flex items-center gap-1 rounded-full border border-black/5 bg-white p-1 text-xs shadow-sm"
    >
      <button
        type="button"
        data-testid="filter-community-btn"
        disabled={!active}
        onClick={() => onToggle?.(false)}
        className={`jirani-pill inline-flex items-center gap-1.5 rounded-full px-3 py-1.5 font-medium transition-colors ${
          !showAll
            ? "bg-[#2E473B] text-white"
            : "text-[#2E473B] hover:bg-[#F9F7F4]"
        }`}
        title={active ? `Only show ${active}` : "Join a community first"}
      >
        <MapPin className="h-3 w-3" />
        {active || "No community"}
      </button>
      <button
        type="button"
        data-testid="filter-all-btn"
        onClick={() => onToggle?.(true)}
        className={`jirani-pill inline-flex items-center gap-1.5 rounded-full px-3 py-1.5 font-medium transition-colors ${
          showAll
            ? "bg-[#2E473B] text-white"
            : "text-[#2E473B] hover:bg-[#F9F7F4]"
        }`}
      >
        <Globe2 className="h-3 w-3" />
        All Nairobi
      </button>
    </div>
  );
}
